export default {
  meta: {
    title: '储备店详情',
    parentPath: ['/storemanage'],
    url: '/storemanage/reserve', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/storemanage/reserve'],
      name: ['储备店管理'],
    },
  },
};
